<div class="container">
  <div class="card">
    <div class="task-head">
      <h4>The map highlights regular collection locations. Tasking in these areas increases the collection.</h4>
    </div>

    <div style="min-width: 200px; position: relative">
      <div id="cesiumContainer" class="cesiumContainer" style="height: 400px"></div>

      <mat-progress-bar *ngIf="dataLoading" class="cesium-progress-bar"
        mode="indeterminate"></mat-progress-bar>

      <div class="d-flex justify-content-center"
        [ngStyle]="{'margin-top': '15px'}">
        <button mat-button class="btn" (keydown)="onKeyPress($event, 'NO')" (click)="onNoClick('NO')">
          Continue
        </button>
      </div>
    </div>
  </div>
</div>